import { createUseStyles } from 'react-jss'
import { Link } from 'react-router-dom'
import { Colors } from '../../constants/colors'
import { CreditFacilityPayoutListItemModel } from '../../redux/types'
import Card from '../Card'
import Pagination from '../Pagination'
import { formatDateString, formatDateTimeString } from '../../utils/dateHelper'
import { formatMoney } from '../../utils/moneyHelper'

export interface Props {
  payoutCreditFacilityId: string
  payoutsOnPage?: CreditFacilityPayoutListItemModel[]
  pageIndex: number
  pageSize: number
  totalCount: number
  onPageChange: (pageIndex: number) => void
}

const CreditFacilityPayoutList = ({ payoutCreditFacilityId, payoutsOnPage, pageIndex, pageSize, totalCount, onPageChange }: Props) => {
  const styles = useStyles()

  const renderHeader = () => {
    return (
      <Card className={`${styles.container} ${styles.header} card`}>
        <div className={styles.smallCell}>
          <h6>Date</h6>
        </div>
        <div className={styles.cell}>
          <h6>Customer reference payout ID</h6>
        </div>
        <div className={styles.smallCell}>
          <h6>Amount</h6>
        </div>
        <div className={styles.cell}>
          <h6>Repayment date</h6>
        </div>
        <div className={`${styles.cell} ${styles.statusContainer}`}>
        <h6>Status</h6>
        </div>
      </Card>
    )
  }

  const renderListItems = () => {
    return payoutsOnPage?.map((item, index) => {
      return (
        <Link to={{pathname: `/payoutcreditfacilities/${payoutCreditFacilityId}/payouts/${item?.id}`}} key={`payout_${index}`}>
          <Card className={styles.container}>
            <div className={styles.smallCell}>
              {formatDateTimeString(item?.created)}
            </div>
            <div className={styles.cell}>
              {item.customerReferencePayoutId}
            </div>
            <div className={styles.smallCell}>
              {formatMoney(item.amount)}
            </div>
            <div className={styles.cell}>
              {formatDateString(item.repaymentDate)}
            </div>
            <div className={`${styles.cell} ${styles.statusContainer} ${styles.status}`}>
              <span>{item?.state}</span>
            </div>
          </Card>
        </Link>
      )
    })
  }

  return (
    <div>
      {renderHeader()}
      {renderListItems()}
      <div className={styles.pagination}>
        <Pagination
          pageIndex={pageIndex}
          itemCount={totalCount}
          pageSize={pageSize}
          siblingCount={1}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  )
}

export default CreditFacilityPayoutList

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    padding: '3px 20px',
    margin: '10px 0',
    transition: '0.4s',
    '&:hover': {
      backgroundColor: Colors.darkGrayHover,
    }
  },
  header: {
    margin: '30px 0 20px 0',
  },
  smallCell: {
    flex: 1,
    padding: '0px 10px'
  },
  cell: {
    flex: 1,
    padding: '0px 10px'
  },
  statusContainer: {
    flex: '0 0 200px',
  },
  status: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: 5,
    padding: '2px 5px',
    backgroundColor: Colors.darkGray3,
    '& span': {
      fontFamily: 'Aestetico-Regular',
      color: Colors.darkGray4,
      fontSize: 14,
    }
  },
  pagination: {
    marginTop: 10,
    display: 'flex',
    justifyContent: 'center'
  }
})
